import React, { useEffect } from 'react'
import useStorage from '../hooks/useStorage'

const ProgressBar = (props) => {

    const { file, setFile, collection, onComplete } = props;
    const { url, progress, backgroundStatus } = useStorage(file, collection);
    console.log(progress, url);

    useEffect(() => {
        if(url){
            setFile(null);
            if (onComplete) onComplete(url);
        }
    }, [url, setFile, onComplete])

    return (
        <div>
            <div className='progress-bar progress-bar-striped bg-info mt-2' style={{width : progress + '%', height: "5px"}}>
            </div>
            {backgroundStatus && <small className="text-muted d-block mt-1">{backgroundStatus}</small>}
        </div>
    )
}

export default ProgressBar
